export default __webpack_public_path__ + "static/media/corbeille-4.cab762ad.png";